import React from "react";

import { Icon } from "../components/icon/icon.component";

// Shown when a Cinch employee lands on the app but isn't a member of ANY
// company. Before we opened the app to all @cinch.io users this state
// wasn't reachable — the whitelist users were all set up. Now any newly-
// onboarded engineer can hit it if IT hasn't added them to a company yet.
// Without this page the app renders a permanent <Loader /> (asCompany
// resolves to null, which AuthCheck's loading check treats as "still
// loading forever").
const NoCompanyPage = () => {
  return (
    <div className="wrapper">
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "40px",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "25px" }}>
          <Icon name="fa-solid-exclamation-triangle" size={24} />
        </div>
        <div style={{ textAlign: "center", fontSize: "20px", marginBottom: "12px" }}>
          Your Cinch account isn't attached to a company yet.
        </div>
        <div style={{ textAlign: "center", fontSize: "14px", color: "#666", maxWidth: "480px" }}>
          Ping IT (or #it-help in Slack) and ask them to add you to a company
          in Cinch. Once that's done, refresh this page.
        </div>
      </div>
    </div>
  );
};

export default NoCompanyPage;
